import ApiService from "../services/ApiService"
import SearchResultModel from "../models/searchresultmodel"
import LatLngPoint from "../models/latlngpoint"
import proj4 from "proj4"
import { store } from '@/store/store'

// export default class LocateMeHelper extends Vue {
export default class LocateMeHelper {
    async setLocationPointView(lat: number, lng: number): Promise<void> {
        // Kun kartta on paikantunut, tehdään koordinaateille käänteinen geokoodaus ja asetetaan osoite Anna sijainti -kenttään
        if (lat && lng) {
            store.dispatch("setLoading", { name: "addressByLocationPoint", value: true })
            const langString = this.currentLanguage.toString()
            const apiservice: ApiService = new ApiService(store.getters.baseHref)
            await apiservice.getReverseGeocodingLocation(lat, lng, langString).then(async (result) => {
                const featureCollection = result.features
                let locationAddress: string = ""
                if (featureCollection[0]) {
                    locationAddress = featureCollection[0].properties.label
                }
                else {
                    const coor = this.coordinates(lat, lng)
                    if (coor.lat && coor.lng) {
                        locationAddress = "E=" + Math.round(coor.lng) + ", N=" + Math.round(coor.lat) + " (ETRS-TM35FIN)"
                    }
                    else {
                        locationAddress = ""
                    }
                }
                const singleData: SearchResultModel = new SearchResultModel(
                    "",
                    "",
                    "",
                    "",
                    locationAddress,
                    new LatLngPoint(lat, lng)
                )
                store.dispatch("setSearchAddressSelected", singleData)
            }).finally(() => {
                store.dispatch("setLoading", { name: "addressByLocationPoint", value: false })
            })
        }
    }

    public coordinates(lat: number, lng: number) {
        const coors = proj4("EPSG:4326", "EPSG:3067", [lng, lat])
        return new LatLngPoint(coors[1], coors[0])
    }

    public get currentLanguage() {
        return store.getters.activeLang
    }
}
